var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showCookiesBar)?_c('cookies-bar',{on:{"onSettingButton":_vm.onSettingButton,"onAcceptAll":_vm.onAcceptAll}}):_vm._e(),(_vm.showCookiesModal)?_c('cookies-modal',{attrs:{"savedAnalyticsCookies":_vm.settings.analyticsCookies},on:{"onSaveSettings":_vm.onSaveSettings}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }